import {
  DesignModuleNode,
  DesignObject,
  ObjectClass
} from '@app/types';
import { mergeAdditive } from '../../functions';

export function mergeDesignObjectModification<
  T extends DesignObject | DesignModuleNode
>(
  source: T,
  target: T
): T {
  switch (source._class) {
    case ObjectClass.prompt:
      source = mergeAdditive(source, target, [
        'props.config.channel',
        'props.config.text'
      ]);
  }

  return source;
}
